import { FacialAuthenticationStatusResponse, LivenessStatusResponse, OperationStatus } from "./selphi";

export enum SseStatus {
    connecting = 'connecting',
    open = 'open',
    error = 'error',
    closed = 'closed',
};

type AuthenticationImages = {
    type: string;
    url: string;
    links?: {
      document: string;
    }
  };
  export type OperationFinishedPayload = {
    status: OperationStatus;
  };

export type Assets = {
    type: string;
    url: string;
};

export type OperationContextPayload = {
    context: {
        customerId: string;
    }
};

export type SelfieCapturedPayload = {
    asset: Assets;
};

export type PassiveLivenessPayload = {
    type?: string;
    diagnostic: LivenessStatusResponse;
    description?: string;
    diagnosticValue?: number;
  };

export type FacialAuthenticationPayload = {
    similarity: number;
    authStatus: FacialAuthenticationStatusResponse;
    links?: {
      document: string;
      assets: AuthenticationImages[],
    }
  };

export enum SseEvents {
    SELFIE_CAPTURED = 'SELFIE_CAPTURED',
    FACIAL_AUTHENTICATION_EVALUATED = 'FACIAL_AUTHENTICATION_EVALUATED',
    PASSIVE_LIVENESS_EVALUATED = 'PASSIVE_LIVENESS_EVALUATED',
    OPERATION_FINISHED = 'OPERATION_FINISHED',
    OPERATION_STARTED = 'OPERATION_STARTED',
    OPERATION_EXPIRED = 'OPERATION_EXPIRED',
};

export type SseResultObject = {
    [SseEvents.OPERATION_STARTED]?: OperationContextPayload;
    [SseEvents.SELFIE_CAPTURED]?: SelfieCapturedPayload;
    [SseEvents.FACIAL_AUTHENTICATION_EVALUATED]?: FacialAuthenticationPayload;
    [SseEvents.PASSIVE_LIVENESS_EVALUATED]?: PassiveLivenessPayload;
    [SseEvents.OPERATION_FINISHED]?: OperationFinishedPayload;
    [SseEvents.OPERATION_EXPIRED]?: OperationContextPayload;
};
